/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import FMPFooter from "examples/Footers/FMPFooter";
import SimpleInfoCard from "examples/Cards/InfoCards/SimpleInfoCard";

// HelpCenter page components
import FaqCollapse from "pages/Ajuda/Faq/components/FaqCollapse";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function Faq() {
  const [collapse, setCollapse] = useState(false);

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/pages/ajuda/contate-nos",
          label: "Contate-nos",
          color: "info",
        }}
        sticky
      />
      <MKBox component="section" pt={20} pb={12}>
        <Container sx={{ mb: 8 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <SimpleInfoCard
                icon="description"
                title="Documentação Técnica"
                description="Encontre aqui documentos técnicos dos nossos produtos de segurança cibernética, centros de comunicações e data centers."
                direction="center"
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <SimpleInfoCard
                icon="support_agent"
                title="Assistência técnica"
                description="Suporte 24/7. Envie o seu chamado de suporte e um de nossos analistas entrará em contato o quanto antes possível."
                direction="center"
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <SimpleInfoCard
                icon="account_balance"
                title="Financeiro"
                description="Solicite suporte com as suas faturas e requisições financeiras."
                direction="center"
              />
            </Grid>
          </Grid>
        </Container>
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Card>
                <MKBox
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  p={3}
                  mt={-3}
                  mx={2}
                >
                  <MKTypography variant="h3" color="white">
                    Perguntas frequentes
                  </MKTypography>
                  <MKTypography variant="body2" color="white" opacity={0.8}>
                    Mais recente atualização: 24 de Julho 2025
                  </MKTypography>
                </MKBox>
                <MKBox p={6}>
                  <MKTypography variant="h5" my={3}>
                    Templar (MDC-SR10 V2)
                  </MKTypography>
                  <FaqCollapse
                    title="O que é o Templar?"
                    open={collapse === 3}
                    onClick={() => (collapse === 3 ? setCollapse(false) : setCollapse(3))}
                  >
                    O Templar é um data center, um centro de comunicações e uma central de controle.<br/><br/>
                    O Templar é um data center de nuvem privada portátil e robusto que pode ser usado em qualquer lugar 
                    para fornecer serviços de computação, dados e comunicação de alta potência. Ele tem dez servidores 
                    blade potentes e um centro de comunicações que lida com todos os sistemas portadores conhecidos. 
                    Com enorme capacidade de armazenamento e memória, ele pode lidar até mesmo com os aplicativos mais 
                    recentes de IA e que consomem muitos recursos.
                  </FaqCollapse>
                  <FaqCollapse
                    title="Como faço para adquirir o Templar?"
                    open={collapse === 1}
                    onClick={() => (collapse === 1 ? setCollapse(false) : setCollapse(1))}
                  >
                    Entre em contato com a nossa equipe de vendas através do email: vendas@fmpsolucoes.com.br
                  </FaqCollapse>
                  <FaqCollapse
                    title="Qual o tempo de entrega?"
                    open={collapse === 2}
                    onClick={() => (collapse === 2 ? setCollapse(false) : setCollapse(2))}
                  >
                    O tempo de entrega varia de acordo com a quantidade e atual fila de produção, porém geralmente as ordens são entregues em
                    até 8 semanas.
                  </FaqCollapse>
                  <FaqCollapse
                    title="Quais são as possibilidades de conexão simultânea?"
                    open={collapse === 4}
                    onClick={() => (collapse === 4 ? setCollapse(false) : setCollapse(4))}
                  >
                    O Templar pode operar conexões ópticas, de rádio, wi-fi e satélite simultaneamente. <br/><br/>
                    Ele pode operar até 300 thin-clients e 7.200 unidades de fala, além de SATCOM e fibra óptica, tudo ao mesmo tempo. 
                    O Cradlepoint integrado suporta balanceamento de carga round-robin e direcionamento de tráfego para otimizar a 
                    utilização da largura de banda e a priorização de aplicativos.
                  </FaqCollapse>
                  <FaqCollapse
                    title="Em caso de falta de eletricidade, eu ainda tenho acesso aos meus dados?"
                    open={collapse === 5}
                    onClick={() => (collapse === 5 ? setCollapse(false) : setCollapse(5))}
                  >
                    O Templar é vendido com duas baterias UPS, uma de 12 horas e outra de 8 horas, que podem ser utilizadas para manter os seus dados
                    e sistemas em funcionamento enquanto a fonte principal de energia está inoperante. Caso as baterias percam a carga antes de a rede
                    elétrica principal retornar ao funcionamento normal, é possível também manter o Templar em funcionamento com painéis solares de 12V
                    e também baterias automotivas.
                  </FaqCollapse>
                  <MKTypography variant="h5" mt={6} mb={3}>
                    Treinamentos
                  </MKTypography>
                  <FaqCollapse
                    title="Como faço para saber quando ocorrerão os próximos treinamentos?"
                    open={collapse === 6}
                    onClick={() => (collapse === 6 ? setCollapse(false) : setCollapse(6))}
                  >
                    Os treinamentos normalmente tem as suas datas publicadas no nosso site com pelo menos 1 mês de antecendência, porém
                    a nossa equipe de atendimento pode ser contatada para responder dúvidas em relação à datas de treinamentos, custos,
                    e solicitação de treinamentos presenciais não-agendados.
                  </FaqCollapse>
                  <FaqCollapse
                    title="Eu me inscrevi, porém não poderei mais comparecer ao treinamento. O que devo fazer?"
                    open={collapse === 7}
                    onClick={() => (collapse === 7 ? setCollapse(false) : setCollapse(7))}
                  >
                    Por favor, entre em contato com a nossa equipe para remover a sua inscrição o quanto antes possível para garantir
                    que seremos capazes de lhe estornar quaisquer valores pagos, de acordo com os Termos e Condições do treinamento.
                  </FaqCollapse>
                  <FaqCollapse
                    title="Eu me inscrevi, paguei e não compareci ao meu treinamento presencial. O que devo fazer?"
                    open={collapse === 8}
                    onClick={() => (collapse === 8 ? setCollapse(false) : setCollapse(8))}
                  >
                    Pedimos que entre em contato com a nossa equipe para que juntos possamos encontrar a melhor solução possível.
                  </FaqCollapse>
                  <FaqCollapse
                    title="Eu não recebi o link do meu treinamento online. O que devo fazer?"
                    open={collapse === 9}
                    onClick={() => (collapse === 9 ? setCollapse(false) : setCollapse(9))}
                  >
                    Pedimos que entre em contato com a nossa equipe para que possamos identificar qual a razão do link não ter sido recebido
                    pelo participante, e quando necessário, gerar um novo link para possibilitar a sua presença.
                  </FaqCollapse>
                  <FaqCollapse
                    title="O treinamento no qual me inscrevi foi cancelado. Receberei um reembolso?"
                    open={collapse === 9}
                    onClick={() => (collapse === 9 ? setCollapse(false) : setCollapse(9))}
                  >
                    Todos treinamentos cancelados pela FMP Soluções serão passíveis de total reembolso de montantes já pagos pelos inscritos.
                  </FaqCollapse>
                  <MKTypography variant="h5" mt={6} mb={3}>
                    Licenças
                  </MKTypography>
                  <FaqCollapse
                    title="Qual a vantagem de comprar licenças através da FMP Soluções e seus parceiros?"
                    open={collapse === 10}
                    onClick={() => (collapse === 10 ? setCollapse(false) : setCollapse(10))}
                  >
                    Todas licenças vendidas pela FMP Soluções, e por nossos parceiros, são vendidas com valores que 
                    mais se aproximem as capacidades do cliente, além de oferecermos suporte em Português e auxílio na implementação.
                  </FaqCollapse>
                  <FaqCollapse
                    title="Como faço a aquisição da licença?"
                    open={collapse === 11}
                    onClick={() => (collapse === 11 ? setCollapse(false) : setCollapse(11))}
                  >
                    Entre em contato conosco através de um de nossos formulários, ou com um de nossos revendedores,
                    e nós lhe auxiliaremos por todo o processo.
                  </FaqCollapse>
                </MKBox>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <FMPFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Faq;
